import React, {useEffect, useState} from "react";
import "./Peyk.scss";
import {HomeHeader} from "../../Components";
import {PeykCurrentCard} from "./PeykCurrentCard/PeykCurrentCard";
import {courier_orders_api} from "./PeykService";
import {useHistory} from "react-router-dom";

function Peyk() {

    const history = useHistory()
    const [currents,set_currents] = useState([])
    useEffect(()=>{
        courier_orders_func();
    },[])


    const courier_orders_func = async ()=>{
        try {
            const response = await courier_orders_api(1)
            console.log("Response : ",response)
            set_currents(response.data.results)
        }catch (e) {
            console.log(e)
        }
    }

    return(
        <div>
            <HomeHeader/>
            {currents.length>0?
                <div className="map-icon" onClick={()=>{
                    history.push("/maps")
                }}>
                    <i className="fa fa-map"></i>
                </div>:null
            }

            {currents.length>0?<div className="task-list">
                {currents.map(item=>{
                    return(
                        <PeykCurrentCard item={item}/>
                    )
                })}
            </div>:<div className="empty-list">
                <i className="fa fa-database"></i>
                <span>سفارشی در لیست وجود ندارد</span>
            </div>}
        </div>
    )
}

export {Peyk}
